var _path, _path2, _g, _g2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6074 7.89258L32.1071 23.3923L9.82297 32.6599C9.1127 32.9553 8.2944 32.7931 7.75046 32.2492L-nan -nanL-nan -nanL7.75046 32.2492C7.20653 31.7053 7.04436 30.887 7.33975 30.1767L16.6074 7.89258Z",
    fill: "url(#paint0_radial_372_3333)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6074 7.89258L7.33975 30.1767C7.04436 30.887 7.20653 31.7053 7.75046 32.2492C8.2944 32.7931 9.1127 32.9553 9.82297 32.6599L32.1071 23.3923L16.6074 7.89258ZM16.6758 8.23776L7.52046 30.2519C7.25551 30.8889 7.40096 31.6229 7.88885 32.1108C8.37675 32.5987 9.11073 32.7442 9.74781 32.4792L31.7619 23.3238L16.6758 8.23776Z",
    fill: "url(#paint1_linear_372_3333)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_372_3333)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1427 17.8565C26.4228 22.1366 30.8839 24.615 32.1068 23.3921C33.0606 22.4382 31.7626 19.5142 29.1142 16.2427L28.9079 15.9904C28.6292 15.6532 28.3365 15.3127 28.0309 14.9707L27.7993 14.714C27.4092 14.2858 26.9992 13.856 26.5712 13.428C26.1432 13 25.7134 12.59 25.2851 12.1999L25.0284 11.9683C24.6865 11.6626 24.346 11.37 24.0088 11.0913L23.7564 10.885C20.4849 8.23653 17.561 6.93854 16.6071 7.89239C15.3842 9.11528 17.8626 13.5764 22.1427 17.8565Z",
    fill: "url(#paint2_radial_372_3333)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_372_3333)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6731 23.4528C31.3097 23.5761 31.7329 23.4892 31.9684 23.2537C32.1518 23.0703 32.2458 22.7743 32.2187 22.3449C32.1917 21.9164 32.045 21.3822 31.7813 20.7632C31.2547 19.5269 30.2801 17.994 28.9624 16.3663C28.9623 16.3661 28.9622 16.366 28.9621 16.3659L28.757 16.1151C28.7569 16.115 28.7568 16.1148 28.7567 16.1147C28.4798 15.7797 28.189 15.4414 27.8853 15.1015C27.8852 15.1014 27.8851 15.1013 27.885 15.1012L27.6546 14.8458C27.6545 14.8457 27.6544 14.8456 27.6543 14.8455C27.2664 14.4197 26.8586 13.9922 26.4328 13.5664C26.007 13.1406 25.5795 12.7328 25.1536 12.3449C25.1535 12.3448 25.1534 12.3447 25.1533 12.3446L24.898 12.1142C24.8979 12.1141 24.8978 12.114 24.8977 12.1139C24.5578 11.8101 24.2195 11.5193 23.8844 11.2425C23.8843 11.2424 23.8842 11.2423 23.8841 11.2422L23.6333 11.0371C23.6332 11.037 23.6331 11.0369 23.633 11.0368C22.0052 9.71913 20.4723 8.74448 19.236 8.21788C18.617 7.95422 18.0828 7.80745 17.6542 7.78046C17.2249 7.75342 16.9289 7.84739 16.7455 8.03078C16.51 8.26627 16.4231 8.68949 16.5464 9.32608C16.6681 9.95458 16.9864 10.7401 17.4824 11.6329C18.473 13.4161 20.1501 15.5871 22.2811 17.7181C24.4121 19.849 26.5831 21.5261 28.3663 22.5168C29.2591 23.0128 30.0446 23.3311 30.6731 23.4528ZM23.7564 10.885L24.0088 11.0913C24.346 11.37 24.6865 11.6626 25.0284 11.9683L25.2851 12.1999C25.7134 12.59 26.1432 13 26.5712 13.428C26.9992 13.856 27.4092 14.2858 27.7993 14.714L28.0309 14.9707C28.3365 15.3127 28.6292 15.6532 28.9079 15.9904L29.1142 16.2427C31.7626 19.5142 33.0606 22.4382 32.1068 23.3921C30.8839 24.615 26.4228 22.1366 22.1427 17.8565C17.8626 13.5764 15.3842 9.11528 16.6071 7.89239C17.561 6.93854 20.4849 8.23653 23.7564 10.885Z",
    fill: "url(#paint3_radial_372_3333)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8627 6.0896L35.8212 6.25855L38.1396 10.4615L39.8627 6.0896Z",
    fill: "#FFDAFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7273 0.840629L19.5227 5.90928L23.6396 5.75276L21.7273 0.840629Z",
    fill: "#5B72F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5898 2.90619C31.0548 3.4412 30.1874 3.4412 29.6524 2.90619C29.1173 2.37117 29.1173 1.50374 29.6524 0.96873C30.1874 0.433715 31.0548 0.433715 31.5898 0.96873C32.1248 1.50374 32.1248 2.37117 31.5898 2.90619Z",
    fill: "#E965E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1855 20.1337C30.6505 20.6687 29.7831 20.6687 29.2481 20.1337C28.7131 19.5987 28.7131 18.7313 29.2481 18.1963C29.7831 17.6613 30.6505 17.6613 31.1855 18.1963C31.7205 18.7313 31.7205 19.5987 31.1855 20.1337Z",
    fill: "#E965E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8824 8.42097C25.4606 8.17982 25.3138 7.64264 25.5543 7.22049V7.22049C25.7953 6.7974 26.334 6.65021 26.7567 6.89192L26.8698 6.9566L27.056 7.06608L27.233 7.1719L27.4035 7.27586C28.5989 8.01216 29.4352 8.69523 29.9822 9.49725L30.0234 9.55875L30.0421 9.58765L30.0914 9.5795C31.8716 9.29257 33.2988 9.91812 34.2765 11.283L34.322 11.3476C34.8604 12.1229 35.3123 13.8929 35.551 14.9715C35.6586 15.4574 35.3267 15.9224 34.8346 15.9968V15.9968C34.3588 16.0687 33.9122 15.7469 33.8136 15.276C33.6196 14.3499 33.2725 12.9244 32.8752 12.3521C32.3399 11.5812 31.6486 11.2045 30.6833 11.2787L30.602 11.2859L30.6029 11.3047C30.6184 11.8644 30.4784 12.4395 30.1706 13.0188L30.1329 13.0883L30.0352 13.2614C28.8257 15.3642 27.4412 16.3117 26.0778 15.9669C24.8835 15.6648 24.1121 14.3609 24.296 13.2C24.542 11.6467 25.6457 10.7216 27.2704 10.2144C27.308 10.2026 27.3485 10.1907 27.3912 10.1785L27.526 10.1418C27.5729 10.1295 27.6216 10.1171 27.6717 10.1046L27.8255 10.0675L27.9844 10.0307L28.1198 10.0005L28.1161 9.9966C27.7438 9.62517 27.2253 9.23976 26.5575 8.82374L26.4798 8.77561L26.3214 8.67906L26.1559 8.5801L25.9805 8.47707L25.8824 8.42097ZM28.8053 11.6721L28.8079 11.6565L28.4705 11.7284L28.2737 11.7725L28.091 11.8158L27.9804 11.8437L27.8812 11.8704L27.7954 11.8957C26.7421 12.2246 26.1561 12.7158 26.0357 13.4755C25.9889 13.7712 26.2368 14.1902 26.5098 14.2592C26.8227 14.3384 27.2869 14.098 27.8455 13.3866L27.924 13.2842C27.9372 13.2667 27.9504 13.2488 27.9637 13.2308L28.044 13.1191C28.0845 13.0617 28.1253 13.0019 28.1666 12.9396L28.2497 12.8119C28.2636 12.7901 28.2776 12.768 28.2916 12.7456L28.3763 12.608L28.4619 12.4638C28.4763 12.4391 28.4907 12.4142 28.5051 12.3891L28.5922 12.2345C28.6985 12.0428 28.7696 11.856 28.8053 11.6721Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_372_3333",
    x: 2.70351,
    y: -6.01121,
    width: 43.3068,
    height: 43.3068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.7957
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_372_3333"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_372_3333",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_372_3333",
    x: 2.70351,
    y: -6.01121,
    width: 43.3068,
    height: 43.3068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.7957
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_372_3333"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_372_3333",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_372_3333",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.3283 10.6518) rotate(49.4017) scale(20.2258 21.6541)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F065E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3748FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_372_3333",
    x1: 7.07434,
    y1: 11.3819,
    x2: 10.0177,
    y2: 28.7707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.29535
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_372_3333",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7912 15.6422) rotate(34.3143) scale(14.3012)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.801593
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#889AFF",
    stopOpacity: 0.301884
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_372_3333",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8502 9.14424) rotate(70.2944) scale(9.29202 14.0563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.973411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotions);
export default __webpack_public_path__ + "static/media/promotions.745040e04de5c6337c9f8012aef6552d.svg";
export { ForwardRef as ReactComponent };